import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  Inject
} from '@angular/core';
import * as _ from 'lodash';

require('./attachment-popup.scss');
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'app-attachment-popup',
  templateUrl: './attachment-popup.html',
})
export class AttachmentPopupComponent implements OnChanges {
  @Input() text: string;
  @Input() link: string;
  @Input() type: string;
  @Input() blobName: string;
  @Input() extraInfo: any;
  @Input() canEdit: boolean;
  @Input() metadata: any;
  @Output() onEdit = new EventEmitter<void>();

  public isPdf: boolean;
  public isVideo: boolean;
  public blobNameCopy: string;
  public isTemporaryUrl: boolean;

  constructor(
    @Inject('$window') private $window: any,
    @Inject('attachmentsService') private attachmentsService: any,
    @Inject('commonsDialogService') private commonsDialogService: any
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.type ||
      (changes.link && !changes.link.isFirstChange()) ||
      (changes.blobName && !changes.blobName.isFirstChange())) {
      if (this.blobName) {
        const blobNameSplitted = this.blobName.split('/');
        this.blobNameCopy = blobNameSplitted[blobNameSplitted.length - 1];
      }
      this.isTemporaryUrl = !this.link || this.link.includes("Expires");
      this.isPdf = (this.type === 'application/pdf' || this.type === '.pdf');
      this.isVideo = (this.type?.includes('video'));
    }
  }

  openPopup(ev: any): void {
    if (this.isTemporaryUrl && this.blobNameCopy) {
      this._getAttachmentByBlobNameUrl(this.blobNameCopy).then((link: string) => {
        this.commonsDialogService.openPodImagePop(ev, link, this.text, this.extraInfo, this.type);
      });
    } else {
      this.commonsDialogService.openPodImagePop(ev, this.link, this.text, this.extraInfo, this.type);
    }
  }

  download(event): void {
    if (this.isTemporaryUrl && this.blobNameCopy) {
      this._getAttachmentByBlobNameUrl(this.blobNameCopy).then(res => this.$window.location.href = res);
    } else {
      this.$window.location.href = this.link;
    }
  }

  private _getAttachmentByBlobNameUrl(blobName: string): Promise<string> {
    return this.attachmentsService.getAttachmentsUrls([blobName])
      .then((attachmentsUrls: any[]) => {
        const mapByName = _.mapKeys(attachmentsUrls, (value, key) => {
          return value.name;
        });
        return _.get(mapByName[this.blobNameCopy], 'url');
      });
  }
}
